/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPicklistOption
 */
export interface PccPicklistOption {
    /**
     * 
     */
    value: string;
}

/**
 * Check if a given object implements the PccPicklistOption interface.
 */
export function instanceOfPccPicklistOption(value: object): value is PccPicklistOption {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function PccPicklistOptionFromJSON(json: any): PccPicklistOption {
    return PccPicklistOptionFromJSONTyped(json, false);
}

export function PccPicklistOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPicklistOption {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function PccPicklistOptionToJSON(json: any): PccPicklistOption {
    return PccPicklistOptionToJSONTyped(json, false);
}

export function PccPicklistOptionToJSONTyped(value?: PccPicklistOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

